@import "../../../styles/variables.scss";

.filter-checkbox-wrapper {
  padding: 6px 0 6px 0;

  &.has-paddings {
    padding: 9px 16px 9px 16px;
  }

  &.filter-disabled {
    position: relative;
    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  }

  label.checkbox-label {
    display: flex;
    cursor: pointer;
    justify-content: space-between;
    width: 100%;

    span.filter-checkbox-text {
      display: flex;

      se-checkbox {
        margin-top: 2px;
      }

      span.checkbox-text {
        margin-left: 8px;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: $svs-anthracite-grey;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        max-height: 44px;
        overflow: hidden;
        text-overflow: ellipsis;

        &.smaller-label {
          font-size: 14px;
          line-height: 16px;

          span.has-highlight {
            font-size: 14px;
            font-weight: 700;

            span.highlight {
              font-size: 14px;
              font-weight: 400;
            }
          }
        }

        span.filter-count {
          color: $svs-se-dark-grey;
        }
      }

      span.checkbox-text[dir="rtl"] {
        margin-left: 0;
        margin-right: 8px;
      }
    }

    span.filter-icon {
    }
  }
}
